// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6914a88a","239":"5cde289b","422":"583da71c","455":"4eb01f92"}[chunkId] + ".chunk.js";
};